import React from 'react';
import { formatDate } from '@factorin/util';

import { Heading, Text } from 'Modules/ui';
import { translate } from 'Modules/core/i18n';

import styles from './index.module.scss';


const SupplyItemComponent = ({ data, t }) => (
    <>
        <Heading component='h1' headingType='h1Element'>
            {t('header', { number: data.Number })}
            &nbsp;&nbsp;
            <Text component='span' textType='light'>
                {t('date', { date: formatDate(data.PrimaryDocumentDate) })}
            </Text>
        </Heading>
        <table className={styles.supplyItem}>
            <tbody>
                <tr>
                    <Text textType='bold' component='td'>
                        {t('data.provider')}
                    </Text>
                    <Text textType='light' component='td'>
                        {data.ProviderFullName}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {t('data.inn', { inn: data.ProviderINN })}
                    </Text>
                </tr>
            </tbody>
        </table>
    </>
);

export const SupplyItem = translate('supplyItem')(SupplyItemComponent);
